// @see in RevenuePluginGraphErrorCode in `registry_service`
export enum CheckoutFailureCode {
  NO_SPONSOR = 'noSponsor',
  INVENTORY_ERROR = 'inventoryError',
  INVENTORY_LOW = 'inventoryLow',
  BAD_ADDRESS = 'badAddress',
  SERVER_ERROR = 'serverError',
  REGISTRY_ERROR = 'registryError',
}
